<template>
    <!-- Work Section-->
	<section class="section pt-0">
		<div class="container">
			<div class="work-section bg-black m-0">
				<div class="row align-items-center bg-01">
					<div class="col-md-12 wow fadeInUp" data-wow-delay="0.2s">
						<div class="section-header text-center">
							<h2 class="text-white">How Truelysell <span
									class="text-linear-primary">Works</span></h2>
							<p class="text-light">Each listing is designed to be clear and concise, providing customers
							</p>
						</div>
					</div>
				</div>
				<div class="row gx-0 gy-4">
					<div class="col-lg-4 d-flex">
						<div class="work-item text-center flex-fill">
							<div class="mb-3">
								<img src="@/assets/img/icons/work-01.svg" alt="img">
							</div>
							<h6 class="text-white mb-2">1. Post a Service</h6>
							<p>After you post a job, our matching system identifies and alerts relevant Provider, who
								can then express interest in your job.</p>
						</div>
					</div>
					<div class="col-lg-4 d-flex">
						<div class="work-item text-center flex-fill">
							<div class="mb-3">
								<img src="@/assets/img/icons/work-01.svg" alt="img">
							</div>
							<h6 class="text-white mb-2">2. Getting Booked & Job done</h6>
							<p>After you post a job, our matching system identifies and alerts relevant Provider, who
								can then express interest in your job.</p>
						</div>
					</div>
					<div class="col-lg-4 d-flex">
						<div class="work-item work-03 text-center flex-fill">
							<div class="mb-3">
								<img src="@/assets/img/icons/work-03.svg" alt="img">
							</div>
							<h6 class="text-white mb-2">3. Get Reviewd & Get Leads</h6>
							<p>After you post a job, our matching system identifies and alerts relevant Provider, who
								can then express interest in your job.</p>
						</div>
					</div>
				</div>
				<div class="work-bg1">
					<img src="@/assets/img/bg/work-bg-01.svg" class="img-fluid" alt="img">
				</div>
				<div class="work-bg2">
					<img src="@/assets/img/bg/work-bg-02.svg" class="img-fluid" alt="img">
				</div>
			</div>
		</div>
	</section>
	<!-- /Work Section -->

	<section class="section pt-0 pb-0">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-12 text-center wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header text-center">
						<h2 class="mb-1">Most <span class="text-linear-primary">Preferred Services</span></h2>
						<p class="sub-title">Each listing is designed to be clear and concise, providing customers</p>
					</div>
				</div>
			</div>
			<div class="popular-slider-3 owl-carousel nav-center">
				<Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                    <Slide v-for="item in HomeWork" :key="item.id">
						<div class="service-item">
							<div class="service-img">
								<div class="img-slider owl-carousel nav-center">
									<Carousel :wrap-around="true" :settingsOne="settingsOne" :breakpointsOne="breakpointsOne">
                                        <Slide v-for="slideItem in item.Slider" :key="slideItem.id">
											<div class="slide-images">
												<router-link to="/details/service-details">
													<img :src="require(`@/assets/img/services/${slideItem.Image}`)" class="img-fluid" alt="img">
												</router-link>
											</div>
										</Slide>
                                        <template #addons>
                                            <Navigation />
                                            <Pagination />
                                        </template>
                                    </Carousel>
								</div>
								<template v-if="item.TradeIcon">
									<div class="trend-icon">
										<span class="bg-success">
											<i class="feather-trending-up"></i>
										</span>
									</div>
								</template>
								<div class="fav-item">
									<a href="javascript:void(0);" class="fav-icon">
										<i class="ti ti-heart"></i>
									</a>
								</div>
							</div>
							<div class="service-content text-start">
								<div class="d-flex align-items-center justify-content-between mb-2">
									<router-link to="/service-provider/provider-details" class="d-flex align-items-center mb-2 service-pro-info">
										<span class="avatar avatar-sm me-2">
											<img :src="require(`@/assets/img/profiles/${item.Avatar}`)" alt="img"
												class="img-fluid rounded-circle">
										</span>
										<p class="fs-14">{{item.Name}}</p>
									</router-link>
									<small class="mb-2">{{item.Price}}</small>
								</div>
								<h6 class="mb-2"><a href="javascript:void(0);">{{item.Title}}</a></h6>
								<div class="d-flex align-items-center justify-content-between">
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>{{item.Reviews}}
									</p>
									<span class="badge badge-dark-transparent fw-medium p-2">{{item.Bookings}}</span>
								</div>
							</div>
						</div>
					</Slide>
                    <template #addons>
                        <Navigation />
                    </template>
                </Carousel>
			</div>			
		</div>
	</section>  
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import HomeWork from '@/assets/json/frontend/home-work.json'
import "vue3-carousel/dist/carousel.css";

export default {
  data() {
    return {
        HomeWork: HomeWork,
        settings: {
            itemsToShow: 1,
            snapAlign: "center",
        },
        breakpoints: {
            575: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            767: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            991: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            1024: {
                itemsToShow: 3,
                snapAlign: "start",
            },
        },
        settingsOne: {
            itemsToShow: 1,
            snapAlign: "center",
        },
        breakpointsOne: {
            575: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            767: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            991: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            1024: {
                itemsToShow: 3,
                snapAlign: "start",
            },
        },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination,
    },
};
</script>